module.exports = __webpack_public_path__ + "static/media/6139.82e40f21.jpg";